import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { converters } from './admin-terms.converters';
import { loaders } from './admin-terms.loaders';
import { AdminTermsFilters } from './admin-terms.types';

export const adminTermsKeys = queryKeyFactory('admin-terms');

export const useAdminTerms = (
  filters: Partial<AdminTermsFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: adminTermsKeys.list(filters),
    queryFn: () => loaders.getTerms({ filters }),
    select: converters.getTerms,
    keepPreviousData: true,
    enabled: options.enabled,
  });
};

export const useAdminTerm = (termId?: string) => {
  return useQuery({
    queryKey: adminTermsKeys.detail(termId ?? ''),
    queryFn: () => loaders.getTerm({ termId: termId ?? '' }),
    select: converters.getTerm,
    enabled: !!termId,
  });
};
